import React, { Component } from 'react';
import { projects } from 'data/projects.json';

import Carousel from 'components/carousel';
import Iphone from 'components/iphone';
import Macbook from 'components/macbook';
import OutboundLink from 'components/outbound-link';
import Wrapper from 'components/wrapper';
import { ProjectDescription, ProjectIntro, ProjectPage } from 'components/project';
import Badge from 'components/badge';
import SocialShare from 'components/social';

import Icon from '../../../components/icon';
import styles from './styles.module.css';
//import Vimeo from'react-vimeo';
//           <Vimeo video={76979871} />

import coverImage from 'components/project/img/Incruizer.jpg';

/*const images = [
  {
    src: require('./img/collection-listing.jpg'),
    description: 'Life with Bird collection listing',
  }
]; */




const mobileImages = [
    {
      src: require('./img/one.png'),
      description: 'Life with Bird product listing mobile',
    },
  {
    src: require('./img/two.png'),
    description: 'Life with Bird product mobile',
  },

  {
    src: require('./img/three.png'),
    description: 'Life with Bird cart mobile',
  }
];

export default class Incruizer extends Component {
  render() {
    const project = projects.find(_project => _project.slug === 'incruizer');

    const image = (
      <img src={coverImage} alt="Cover" />
    );

    const iphone = (
      <Iphone invert>
        <Carousel images={mobileImages} />
      </Iphone>
    );

    var textStyle= {
      textAlign: "left",
      fontSize: 20,
      color: (project.slug== 'incruizer') ? 'black' : 'white'
    }

    var speStyle={
      fontWeight: 'bold',
      fontSize: 22
    }

    return (
      <ProjectPage project={project}>
        <ProjectIntro project={project} media={image} />
          <ProjectDescription
            media={iphone}
            >
              <h2 style={{color: 'black'}}>Comment ça marche ?</h2>
              <wrapper className={styles.sectionImg}>

                <p style={textStyle}>Partagez des <text style={speStyle}>vidéos</text> de moins de 7 secondes.</p>
              </wrapper>

              <wrapper className={styles.sectionImg}>

                <p style={textStyle}>Ces vidéos seront partager sur une <text style={speStyle}>carte</text> interactif pour tous vos followers.</p>
              </wrapper>

              <wrapper className={styles.sectionImg}>

                <p style={textStyle}>Sur cette carte vous pourrez <text style={speStyle}>voir</text> des vidéos du monde entier avec leur localisation précise.</p>
              </wrapper>

              <wrapper className={styles.sectionImg}>
                  <p style={textStyle, {color: '#F80702'}}><text style={speStyle}>Projet avorté</text> suite à la dernière mises à jour de snapchat faite avec l'acquisition de Zenly.
                  </p>

              </wrapper>

           </ProjectDescription>

      </ProjectPage>
    );
  }
}

/*
<h3>Après les présidentielle 2017 ?</h3>
<p>SwiPolitique deviendra SwipCity ! <br />
Vous pourrez swiper entre les différentes caractéristique des grandes villes, cela vous aidera peut-être à prendre votre prochaine destination de vacances.</p>

*/
/*
<h3>Mais est-ce que cela va m'interesser ?</h3>
<p>C'est simple si vous aimez faire des choix et que vous aimez le concret ? C'est que vous êtes surement un roi ou une reine. </p>
<p>Vous adoré l'ordre, l'organisation et analysé les details. Vous ne rateriez surement pas les prochaines votes aux éléctions </p>
<p>Si c'est le cas cette application est faite pour vous.</p>
*/

//          <OutboundLink to="http://inlight.com.au">Inlight</OutboundLink>

/*
<Macbook>
  <Carousel images={images} />
</Macbook>
*/



// WEBPACK FOOTER //
// ./work/incruizer/index.jsx